export const ADDON_CREATE_REQUEST = "ADDON_CREATE_REQUEST";
export const ADDON_CREATE_SUCCESS = "ADDON_CREATE_SUCCESS";
export const ADDON_CREATE_FAIL = "ADDON_CREATE_FAIL";

export const ADDON_LIST_REQUEST = "ADDON_LIST_REQUEST";
export const ADDON_LIST_SUCCESS = "ADDON_LIST_SUCCESS";
export const ADDON_LIST_FAIL = "ADDON_LIST_FAIL";

export const ADDON_DELETE_REQUEST = "ADDON_DELETE_REQUEST";
export const ADDON_DELETE_SUCCESS = "ADDON_DELETE_SUCCESS";
export const ADDON_DELETE_FAIL = "ADDON_DELETE_FAIL";

export const ADDON_DETAILS_REQUEST = "ADDON_DETAILS_REQUEST";
export const ADDON_DETAILS_SUCCESS = "ADDON_DETAILS_SUCCESS";
export const ADDON_DETAILS_FAIL = "ADDON_DETAILS_FAIL";
export const ADDON_DETAILS_RESET = "ADDON_DETAILS_RESET";

export const ADDON_UPDATE_REQUEST = "ADDON_UPDATE_REQUEST";
export const ADDON_UPDATE_SUCCESS = "ADDON_UPDATE_SUCCESS";
export const ADDON_UPDATE_FAIL = "ADDON_UPDATE_FAIL";
export const ADDON_UPDATE_RESET = "ADDON_UPDATE_RESET";
